/**
 * PURPOSE: Media cancha compacta por equipo para el visualizador de vóley.
 * ROUTE: src/pages/VolleyballViewer/components/ViewerTeamCourt.jsx
 */

import ViewerPositionCard from "./ViewerPositionCard.jsx";
import { byPosition, LEFT_COURT_LAYOUT, RIGHT_COURT_LAYOUT, romanPosition, teamLabel } from "../utils/volleyballViewerCourt.js";

export default function ViewerTeamCourt({ team, players, side = "left", servingTeam }) {
  const map = byPosition(players);
  const layout = side === "left" ? LEFT_COURT_LAYOUT : RIGHT_COURT_LAYOUT;
  const teamCode = team?.teamCode;
  const serving = servingTeam === teamCode;
  const label = String(teamLabel(team));

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border border-orange-500/80 bg-gradient-to-br from-orange-400 via-orange-300 to-amber-300 p-1.5 shadow-inner">
      {/* Sin logo: la sigla ocupa la franja y se ajusta a su ancho/alto (cq); sin soporte queda el tamaño anterior. */}
      <div className="mb-1 flex h-7 shrink-0 items-center justify-center rounded-xl bg-white/90 px-1 text-center shadow-sm ring-1 ring-orange-100/80 [container-type:size]">
        <div className="flex w-full min-w-0 items-center justify-center">
          <div
            className="min-w-0 truncate text-[11px] font-black uppercase leading-tight tracking-[0.03em] text-slate-950 supports-[height:1cqh]:text-[length:clamp(11px,calc(100cqw/(var(--sigla-len)*0.8)),74cqh)]"
            style={{ "--sigla-len": String(Math.max(label.length, 4)) }}
          >
            {label}
          </div>
        </div>
      </div>

      <div className="grid min-h-0 flex-1 grid-cols-2 grid-rows-3 gap-1.5">
        {layout.flat().map((position) => {
          const player = map.get(position) || { position, positionLabel: romanPosition(position), jersey: "-" };
          return (
            <ViewerPositionCard
              key={position}
              player={{ ...player, position, positionLabel: player.positionLabel || romanPosition(position) }}
              serving={serving && position === 1}
            />
          );
        })}
      </div>
    </div>
  );
}
